import Alert from "react-bootstrap/Alert";

import PropTypes from "prop-types";

import { useEffect } from "react";

const AlertMessage = ({ variant, successHeading, mainMessage, onClose }) => {
  useEffect(() => {
    setTimeout(function () {
      onClose();
    }, 5000);
  });

  return (
    <Alert
      dismissible={true}
      onClose={onClose}
      variant={variant}
      className="alert-message-reghub"
    >
      <Alert.Heading>{successHeading}</Alert.Heading>
      <hr />
      <p>{mainMessage}</p>
    </Alert>
  );
};

AlertMessage.propTypes = {
  variant: PropTypes.string.isRequired,
  successHeading: PropTypes.string.isRequired,
  mainMessage: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

AlertMessage.defaultProps = {
  variant: "",
  successHeading: "",
  mainMessage: "",
  onClose: () => {},
};

export default AlertMessage;
